(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});

  // Paylaş satırı: sosyal ağ paylaşım penceresi + bağlantı kopyalama.
  DNB.Share = {
    init: function () {
      var buttons = document.querySelectorAll("[data-share]");
      if (!buttons.length) return;

      Array.prototype.forEach.call(buttons, function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();

          var net = btn.getAttribute("data-share");
          var url = encodeURIComponent(window.location.href);
          var title = encodeURIComponent(document.title || "");
          var target = "";

          switch (net) {
            case "facebook":
              target = "https://www.facebook.com/sharer/sharer.php?u=" + url;
              break;
            case "x":
            case "twitter":
                  /*target = "https://twitter.com/intent/tweet?url=" + url + "&text=" + title;*/
                  target = "https://twitter.com/intent/tweet?url=" + url;
              break;
            case "linkedin":
              target = "https://www.linkedin.com/sharing/share-offsite/?url=" + url;
              break;
            case "instagram":
              // Instagram doğrudan web paylaşımı desteklemez → profile yönlendir.
              target = "https://www.instagram.com/";
              break;
            case "copy":
              DNB.Share._copy(window.location.href, btn);
              return;
            default:
              return;
          }

          window.open(target, "_blank", "noopener,noreferrer,width=640,height=560");
        });
      });
    },

    _copy: function (text, btn) {
      var done = function () { btn.classList.add("is-copied"); setTimeout(function () { btn.classList.remove("is-copied"); }, 1500); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(function () {});
      }
    }
  };
})(window, document);
